@defer (when loaded()) {
  <mat-slide-toggle (change)="switch($event)" [checked]="enable()">
    {{ 'shell.header.salesToggle' | translate }}
  </mat-slide-toggle>
} @placeholder (minimum 1s) {
  <div class="pp-shimmer"></div>
}
